module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warningmsg-wrapper dash-item col-md-4",
    attrs: {
      "id": "warningmsg"
    }
  }, [_c('div', {
    staticClass: "warningmsg-header-box dash-bg-color-skin-light-10"
  }, [_c('div', {
    staticClass: "header-center"
  }, [_c('div', {
    staticClass: "rec"
  }), _vm._v("\n      " + _vm._s(_vm.app.home[_vm.app.nowLang].warningmsg) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "warningmsg-content-box"
  }, _vm._l((_vm.warningmsg.rows), function(textwarningmsg, index) {
    return _c('div', {
      staticClass: "warningmsg-content",
      class: {
        'row-even': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(textwarningmsg.message) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-981563ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/warningmsg/component.vue
// module id = 3928
// module chunks = 1